(function() {
    angular
        .module("app")
        .controller("WzDeleteModalController", WzDeleteModalController)

    WzDeleteModalController.$inject = [
        "$rootScope",
        "$scope",
        "$uibModalInstance",
        "wzService",
        "wzTitle",
        "wzID",
        "success",
        "failure"
    ]

    function WzDeleteModalController(
        $rootScope,
        $scope,
        $uibModalInstance,
        wzService,
        wzTitle,
        wzID,
        success,
        failure
    ){
        "use strict"

        $scope.wzTitle = wzTitle
        $scope.wzID    = wzID

        $scope.cancel = () => {
            $uibModalInstance.dismiss("cancel")
        }

        const _success = (data) => {

            gtag("event", "delete_workzone", { wz_id: data.id })

            wzService.listAll($rootScope.selectedCustomerID).then((wzs) => {
                $rootScope.wzs = wzs
            })

            success(data)

        }

        $scope.delete = () => {
            $uibModalInstance.close(wzService.delete(wzID, _success, failure))
        }
    }
})()
